export default "__VITE_ASSET__wqPdw4qd__"